import { render, staticRenderFns } from "./DefaultJsonConfigEditor.vue?vue&type=template&id=5bd351c6&scoped=true&"
import script from "./DefaultJsonConfigEditor.vue?vue&type=script&lang=js&"
export * from "./DefaultJsonConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd351c6",
  null
  
)

export default component.exports